import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const INITIALIZE = `${NAMESPACE}/INITIALIZE`;
export const JOB_SELECTION_TOGGLE = `${NAMESPACE}/JOB_SELECTION_TOGGLE`;
export const JOB_SELECTION_CLEAR = `${NAMESPACE}/JOB_SELECTION_CLEAR`;
export const JOB_SELECTION_SET = `${NAMESPACE}/JOB_SELECTION_SET`;

export const GET_USERS = createApiConstants(NAMESPACE, 'GET_USERS');
